import React from 'react';
import styled from 'styled-components';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

type ElementType = 'label' | 'div' | 'span';

interface LabelProps {
  as: string;
  children?: React.ReactNode;
  dataTest?: string;
}

export interface FormLabelProps {
  as?: ElementType;
  for?: string;
  children?: React.ReactNode;
  className?: string;
  invalid?: boolean;
  name?: string;
  maxLines?: number;
  /**
   * Breaks a word anywhere rather than only where it could. Without it a run with no space in it -
   * a url, a hash, a pasted token - is one unbreakable word: it cannot wrap, so it sets the width
   * of whatever holds it and spills out of it rather than filling the lines `maxLines` allows.
   *
   * Only read alongside `maxLines`, which is what draws the lines to be kept to.
   */
  maxLinesStrict?: boolean;
}

const Label = ({ as, children, dataTest }: LabelProps) =>
  React.createElement(as, { dataTest }, children);

const StyledLabel = styled(Label)`
  vertical-align: middle;
  padding-top: 3px;
`;

export const FormLabel = ({
  as = 'label',
  for: forProp,
  children,
  className = '',
  invalid = false,
  name,
  maxLines,
  maxLinesStrict = false,
}: FormLabelProps) => (
  <StyledLabel
    as={as}
    className={AttrsHelper.formatClassname(
      'form-label',
      maxLines && `max-lines-${maxLinesStrict ? 'strict-' : ''}${maxLines}`,
      invalid && 'invalid',
      className
    )}
    data-test={name || JSON.stringify(children)}
    htmlFor={forProp}
  >
    {children}
  </StyledLabel>
);
